<div class="px-3 py-2">
	<h4 align="center">SESSIONE DELL'INIZIATIVA DE COMPONENDIS CIFRIS IN ITASEC18</h4>
	<p> Il giorno 8 febbraio 2018 si è tenuta una sessione della costituenda 
		associazione nazionale di crittografia De Componendis Cifris all'interno 
		dell'evento <a href="https://itasec.it/past_editions/2018.html">ITASEC18</a>. 
		Nell'evento si è fornita una breve presentazione della De Cifris, seguita da 
		un tutorial sulla Post-Quantum Cryptography.
	</p>
	<h6>Programma</h6>
	<ul>
		<li>
			<p>Presentazione De Componendis Cifris</p>
			<ul class="ulSon">
				<li>
					<p>
						Prof. M. Sala <br>
						Acting Director De Cifris, UNITN <br>
						<i>De Componendis Cifris: a national initiative in cryptography</i>
					</p>
				</li>
				<li>
					<p>
						Prof. M. Giulietti <br>
						UNIPG <br>
						<a href="../../../../assets/eventi/2018/ITASEC/20180208_DeCifris_M_Giulietti.pdf">De 
							Cifris: our research lines</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p>Tutorial Post-Quantum Cryptography</p>
			<ul class="ulSon">
				<li>
					<p>
						Prof. F. Chiaraluce <br>
						UNIVPM <br>
						<a href="../../../../assets/eventi/2018/ITASEC/20180208_DeCifris_F_Chiaraluce.pdf">
							Overview of the NIST Post-Quantum Standardization Initiative </a>
					</p>
				</li>
				<li>
					<p>
						Prof. M. Baldi e Dott. A. Barenghi <br>
						UNIVPM <br>
						<a href="../../../../assets/eventi/2018/ITASEC/20180208_DeCifris_A_Barenghi.pdf">
							Post-Quantum Cryptosystems Based on Error-Correcting Codes</a>
					</p>
				</li>
				<li>
					<p>
						Dott. C. Boschini <br>
						IBM Zurich <br>
						<a href="../../../../assets/eventi/2018/ITASEC/20180208_DeCifris_C_Boschini.pdf">
							Post-Quantum Cryptosystems Based on Lattices</a>
					</p>
				</li>
				<li>
					<p>
						Dott. F. Pintore <br>
						UNITN <br>
						<a href="../../../../assets/eventi/2018/ITASEC/20180208_DeCifris_F_Pintore.pdf">
							Post-Quantum Cryptosystems Based on Elliptic Curve Isogenies</a>
					</p>
				</li>
			</ul>
		</li>
	</ul>
</div>